import emojiLoader from './EmojiLoader'
import { LocalHeyboxEmoji, TWEmojiType, CategoryItem } from './type'
import twCategories from './twemojis/categories'

import { formatMeMeUrl } from '_lib/utils/utilsImg'
import { getRoomIconStr } from '_lib/utils/utilsRoom';
import store from "@/store";

import { CUSTOM_EMOJI_TYPE, ROOM_NAME_AVATAR_PREFIX } from '@/common/constants/emoji-upload';
import { deepCopy } from '_lib/utils/utils';
import EventBus from '_lib/EventBus';
import { getTwEmojiUrl } from '_lib/utils/utils'
import { CUSTOM_EMOJI_HOST } from './type'
const HEYBOX_EMOJI_TYPES = new Set(['cube', 'heygirl'])
const TW_EMOJI_TYPES = new Set(Object.keys(TWEmojiType))
class EmojiRender {
  heyboxEmojis: {
    cube: LocalHeyboxEmoji[],
    heygirl: LocalHeyboxEmoji[],
    sticker: LocalHeyboxEmoji[]
  };
  heyboxEmojisInited: boolean = false;
  heyboxEmojisIniting: boolean = false;

  twEmojis: any = null;
  twEmojisInited: boolean = false;
  twEmojisIniting: boolean = false;

  customEmojis: any = null;
  customEmojisInited: boolean = false;
  customEmojisIniting: boolean = false;

  waitRenderEmojis: string[] = [];
  constructor() {
    
  }
  checkWaitRenderEmojis () {
    if (this.waitRenderEmojis.length && !this.heyboxEmojisIniting && !this.twEmojisIniting && !this.customEmojisIniting) {
      Promise.resolve().then(() => {
        this.waitRenderEmojis.forEach(v => {
          const el = document.querySelector(`.${v}`)
          if (el) {
            const emoji = this.getEmojiByText(el.getAttribute('data-emoji'))
            if (emoji) {
              const html = this.getEmojiImgDom(emoji)
              el.outerHTML = html
            } else {
              console.error('not found emoji', el, el.getAttribute('data-emoji'));
              const parentNode = el.parentNode as HTMLDivElement
              el.remove()
              if (parentNode && parentNode.classList.contains('emoji-reply-item')) {
                parentNode.remove()
              }
            }
          }
        })
        EventBus.$emit('Update_IM_Msg_Emoji_Render')
        this.waitRenderEmojis = []
      })
    }
  }
  async getHeyboxEmojis () {
    if (this.heyboxEmojisInited) {
      this.checkWaitRenderEmojis()
      return this.heyboxEmojis
    }
    if (this.heyboxEmojisIniting) return
    this.heyboxEmojisIniting = true
    this.heyboxEmojis = await emojiLoader.loadEmojiModule('heybox')
    this.heyboxEmojisInited = true
    this.heyboxEmojisIniting = false
    this.checkWaitRenderEmojis()
    return this.heyboxEmojis
  }
  async getTwEmojis () {
    if (this.twEmojisInited) {
      this.checkWaitRenderEmojis()
      return this.twEmojis
    }
    if (this.twEmojisIniting) return
    this.twEmojisIniting = true
    this.twEmojis = await emojiLoader.loadEmojiModule('twemoji')
    this.twEmojisInited = true
    this.twEmojisIniting = false
    this.checkWaitRenderEmojis()
    return this.twEmojis
  }
  async getCustomEmojis () {
    if (this.customEmojisInited) {
      this.checkWaitRenderEmojis()
      return this.customEmojis
    }
    if (this.customEmojisIniting) return
    this.customEmojisIniting = true
    this.customEmojis = await emojiLoader.loadEmojiModule('custom')
    this.customEmojisInited = true
    this.customEmojisIniting = false
    this.checkWaitRenderEmojis()
    return this.customEmojis
  }
  async initCustomCategories () {
    if (!this.customEmojisInited) {
      await this.getCustomEmojis()
    }
    if (!this.customEmojis) {
      return {
        categories: [],
        sticker_categories: []
      }
    }
    let { emoji, sticker, rooms } = this.customEmojis
    // 清除自定义表情
    const categories = []
    const sticker_categories = []
    let temp_rooms = [...rooms]
    if (sticker.interactive_sticker && sticker.interactive_sticker.length) {
      temp_rooms.unshift({
        room_id: 'interactive_sticker',
        avatar: 'https://imgheybox.max-c.com/oa/2024/01/19/d5e6e493bee7e5985d74beb228443dca.png',
        name: '互动表情'
      })
    }

    // 增加自身id到rooms中
    temp_rooms.unshift({
      room_id: store.getters.user_info.user_id,
      avatar: 'https://imgheybox.max-c.com/oa/2023/08/29/ffff5436f0ef0d318eef52fdd1469b0e.png',
      name: '我的收藏'
    })
    temp_rooms = temp_rooms.reverse()

    for (let room of temp_rooms) {
      let id = room.room_id
      // emoji增加自定义
      if (emoji[id] !== undefined) {
        const emojis = emoji[id]
        if (emojis.length) {
          const cateItem = {
            isCustom: true,
            title: room.name,
            name: room.name,
            type: CUSTOM_EMOJI_TYPE + id,
            prefix: CUSTOM_EMOJI_HOST,
            size: 'small',
            img: room.avatar // 优先取房间头像
              || (room.name && (ROOM_NAME_AVATAR_PREFIX + getRoomIconStr(room.name))) // 其次使用房间名称作为头像
              ||`${CUSTOM_EMOJI_HOST}${emojis[0].path}.${emojis[0].ext}`, // 使用首张图作为group的图片,
            list: emojis.map(v => {
              return {
                isCustom: true,
                name: v.name,
                type: CUSTOM_EMOJI_TYPE + id,
                url: (v.path && v.path.startsWith('https://')) ? v.path :`${CUSTOM_EMOJI_HOST}${v.path}.${v.ext}`,
              }
            })
          }
          categories.unshift(cateItem)
        }
      }
      
      // sticker增加自定义
      if (sticker[id] !== undefined) {
        const stickers = deepCopy(sticker[id])
        if (id == store.getters.user_info.user_id) {
          stickers.unshift({
            is_upload_block: true
          })
        }
        if (stickers.length) {
          const group = {
            name: room.name,
            ancher: CUSTOM_EMOJI_TYPE + room.room_id,
            isCustom: true,
            categories: [
              {
                name: 'custom',
                type: CUSTOM_EMOJI_TYPE + room.room_id,
                title: room.name,
                prefix: CUSTOM_EMOJI_HOST,
                size: 'large',
                isCustom: true,
                img: room.avatar // 优先取房间头像
                || (room.name && (ROOM_NAME_AVATAR_PREFIX + getRoomIconStr(room.name))) // 其次使用房间名称作为头像
                ||`${CUSTOM_EMOJI_HOST}${stickers[0].path}.${stickers[0].ext}`, // 使用首张图作为group的图片
              }
            ]
          }
          let cateItem = deepCopy(group.categories)
          cateItem[0].list = stickers.map(v => {
            return {
              name: v.name,
              path: v.path,
              type: CUSTOM_EMOJI_TYPE + id,
              url: (v.path && v.path.startsWith('https://')) ? v.path :`${CUSTOM_EMOJI_HOST}${v.path}.${v.ext}`,
              avatar: v.avatar || '',
              icon: `${v.path}.${v.ext}`,
              is_upload_block: v.is_upload_block,
              nickname: v.nickname,
              isCustom: true,
            }
          })
          cateItem[0].isCustom = true
          sticker_categories.unshift(cateItem[0])
        }
      }
    }
    return {
      categories,
      sticker_categories
    }
  }
  private getEmojiTypeAndName (text: string) {
    // 先判断是不是中括号包裹
    if (text.startsWith('[') && text.endsWith(']')) {
      text = text.slice(1, -1)
    }
    const first_idx = text.indexOf('_')
    if (first_idx === -1) {
      return {
        emoji_type: '',
        emoji_name: text
      }
    } 
    const emoji_type = text.slice(0, first_idx)
    const emoji_name = text.slice(first_idx + 1)
    return {
      emoji_type,
      emoji_name
    }
  }
  
  private async initHeyboxCategories () {
    if (!this.heyboxEmojisInited) {
      await this.getHeyboxEmojis()
    }
    const list: CategoryItem[] = [
      {
        "name": "cube",
        "title": "小黑盒cube",
        "type": "cube",
        "prefix": "https://static.max-c.com/static/heybox-chat/cubeEmoticons/",
        "size": "small",
        "ext": ".png",
        "img": "https://static.max-c.com/static/heybox-chat/cubeEmoticons/微笑.png",
        list: this.heyboxEmojis.cube
      },
      {
        "name": "heygirl",
        "title": "小黑盒盒娘",
        "type": "heygirl",
        "prefix": "https://static.max-c.com/static/heybox-chat/heygirlEmoticons/",
        "size": "small",
        "ext": ".png",
        "img": "https://static.max-c.com/static/heybox-chat/heygirlEmoticons/喜欢.png",
        list: this.heyboxEmojis.heygirl
      },
    ]
    for (let d of list) {
      this.formatCategoryItem(d)
    }
    return list
  }
  private async initTwCategories () {
    if (!this.twEmojisInited) {
      await this.getTwEmojis()
    }
    const list: CategoryItem[] = twCategories
    for (let d of list) {
      d.list = this.twEmojis[TWEmojiType[d.type]].list
      this.formatCategoryItem(d)
    }
    return list
  }
  private async initStickerCategories () {
    if (!this.heyboxEmojisInited) {
      await this.getHeyboxEmojis()
    }
    const list: CategoryItem[] = [{
      "name": "heygirl",
      "title": "小黑盒盒娘",
      "type": "heygirl",
      "prefix": "https://static.max-c.com/static/heybox-chat/heygirlEmoticons/",
      "size": "large",
      "ext": ".png",
      "img": "https://static.max-c.com/static/heybox-chat/heygirlEmoticons/嘻嘻.png",
      list: this.heyboxEmojis?.sticker || []
    }]
    return list
  }
  private formatCategoryItem (category: CategoryItem) {
    for (let d of category.list) {
      if (!HEYBOX_EMOJI_TYPES.has(d.type) && d.type?.indexOf(CUSTOM_EMOJI_TYPE) === -1) {
        for (let t of d.type.split(',')) {
          d.url = getTwEmojiUrl(d.icon)
        }
      } else {
        if (!d.url) {
          d.url = category.prefix + d.name + category.ext
        }
      }
    }
  }
  replaceEmojiByTextName (content: string, is_hb_editor = false, emoji_info?: any) {
    const str = content.replace(/\[(\w{1,30}_.+?)\]/gi, (text, match, offset) => {
      // 检查匹配的文本是否在 alt 属性中
      const beforeText = content.substring(0, offset);
      const altMatch = beforeText.match(/alt\s*=\s*["'][^"']*$/);
      if (altMatch) {
        return text; // 如果在 alt 属性中，不做处理
      }
      
      let emoji = this.getEmojiByText(text, true, emoji_info)
      if (emoji === 'wait') {
        const html = this.getEmojiImgDom(text, true)
        return html
      }
      // 没有自定义表情的话就返回空
      if (!emoji && text.startsWith(`[${CUSTOM_EMOJI_TYPE}`)) {
        return ''
      }
      if (!emoji || content.includes('/heybox/emoji') || content.includes('<img class="small"')) {
        return text
      }
      return is_hb_editor ? this.getEmojiImgDomHbEditor(emoji) : this.getEmojiImgDom(emoji)
    })
    return str
  }
  getCustomEmojiUrl (emoji: {emoji: string, path: string, ext: string; url?: string}) {
    if (!emoji) return ''
    if (emoji.url) return emoji.url
    if (emoji.path && emoji.ext) {
      return `${CUSTOM_EMOJI_HOST}${emoji.path}.${emoji.ext}`
    }
    const _emoji = this.getEmojiByText(emoji.emoji)
    if (_emoji) {
      return _emoji.url
    }
    return ''
  }
  async getEmojiList(type: string, clear_custom = false) {
    let categories = []
    if (clear_custom) {
      this.customEmojisInited = false
    }
    const allCustomCategories = await this.initCustomCategories()
    const customCategories = allCustomCategories.categories
    const customStickerCategories = allCustomCategories.sticker_categories
    if (type === 'emojis' || type === 'emoji_groups') {
      categories = [
        ...customCategories,
        ...(await this.initHeyboxCategories()),
        ...(await this.initTwCategories()),
      ]
      
      if (type === 'emojis') {
        return categories
      } else {
        return categories.map(v => {
          return {
            name: v.title,
            img: v.img || this.twEmojis[TWEmojiType[v.type]]?.img,
            ancher: v.type,
            isCustom: v.isCustom
          }
        })
      }
    }

    let sticker_categories = []
    if (type === 'stickers' || type === 'sticker_groups') {
      sticker_categories = [
        ...customStickerCategories,
        ...(await this.initStickerCategories())
      ]
      
      if (type === 'stickers') {
        return sticker_categories
      } else {
        return sticker_categories.map(v => {
          return {
            name: v.title,
            img: v.img,
            ancher: v.type
          }
        })
      }
    }
    return {
      emojis: categories,
      stickers: sticker_categories
    }
  }
  getEmojiByFont (emoji) {
    if (!emoji.class) return emoji
    let type = emoji.class.split('hb-emoji-')[1]
    if (type === 'heycube') {
      type = 'cube'
    }
    let name = emoji.name
    for (let twkey in TWEmojiType) {
      if (TWEmojiType[twkey] === type) {
        type = twkey
        name = emoji.icon
        break
      }
    }
    return this.getEmojiByText(`[${type}_${name}]`)
  }

  // 传入[cube_xxx]，返回一个emoji对象
  private getHeyboxEmojiByText (content: string, emojis) { 
    if (!emojis) return ''
    const { cube, heygirl } = emojis
    const { emoji_name } = this.getEmojiTypeAndName(content)
    return cube.find(v => v.name === emoji_name) || heygirl.find(v => v.name === emoji_name)
  }
  // 传入[1_😂]，返回一个emoji对象
  getTwEmojiByText (content: string, twEmojis: any) {
    if (!twEmojis) return ''
    const { emoji_type, emoji_name } = this.getEmojiTypeAndName(content)
    let res = null
    if (emoji_type) {
      res = twEmojis[TWEmojiType[emoji_type]]?.list.find(v => v.icon === emoji_name)
    }
    for (let type in twEmojis) {
      const list = twEmojis[type]?.list || []
      if (list.find(v => v.icon === emoji_name)) {
        res = list.find(v => v.icon === emoji_name)
        break
      }
    }
    if (res) {
      res.url = getTwEmojiUrl(res.icon)
    }
    return res
  }
  // 传入[custom_xxx]，返回一个emoji对象
  private getCustomEmojiByText(text: string) {
    let { emoji_type, emoji_name } = this.getEmojiTypeAndName(text)
    const room_id = emoji_type.slice(CUSTOM_EMOJI_TYPE.length)
    const room_emojis = this.customEmojis.emoji[room_id]
    if (!room_emojis) return null
    emoji_name = emoji_name.split('.')[0]
    if (!room_emojis) return null
    const emoji = room_emojis.find(v => (v.name === emoji_name) || (v.path === emoji_name))
    if (!emoji) return null
    if (!emoji.url) {
      emoji.url = `${CUSTOM_EMOJI_HOST}${emoji.path}.${emoji.ext}`
    }
    if (!emoji.type) {
      emoji.type = `custom${room_id}`
    }
    return emoji
  }
  private getEmojiByText (text: string, is_replace = false, emoji_info?: any) {
    const { emoji_type, emoji_name } = this.getEmojiTypeAndName(text)
    // 自定义表情会走这个逻辑
    if (emoji_info && emoji_info[emoji_type + '_' + emoji_name]) {
      const emoji = emoji_info[emoji_type + '_' + emoji_name]
      return {
        url: `${CUSTOM_EMOJI_HOST}${emoji.path}.${emoji.ext}`,
        type: emoji_type,
        name: emoji.name,
        ext: emoji.ext || 'png'
      }
    }
    if (HEYBOX_EMOJI_TYPES.has(emoji_type)) {
      if (!this.heyboxEmojisInited) {
        this.getHeyboxEmojis()
        return 'wait'
      }
      return this.getHeyboxEmojiByText(text, this.heyboxEmojis)
    }
    if (TW_EMOJI_TYPES.has(emoji_type)) {
      if (is_replace) {
        return {
          type: emoji_type,
          icon: emoji_name,
          url: getTwEmojiUrl(emoji_name)
        }
      } else {
        if (!this.twEmojisInited) {
          this.getTwEmojis()
          return 'wait'
        }
        return this.getTwEmojiByText(text, this.twEmojis)
      }
    }
    if (emoji_type.startsWith(CUSTOM_EMOJI_TYPE)) {
      if (!this.customEmojisInited) {
        this.getCustomEmojis()
        return 'wait'
      }
      return this.getCustomEmojiByText(text)
    }
    return null
  }
  private getEmojiImgDomHbEditor (emoji) {
    emoji.size = emoji.size || 'small'
    switch (emoji.size) {
      case 'small':
      case 'medium':
        emoji.url = formatMeMeUrl(emoji.url, 'emoji')
        break
      case 'large':
        emoji.url = formatMeMeUrl(emoji.url, 'sticker')
        break
      default:
    }
    return `<img class="hb-chat-inline-emoji" data-emoji="1" src="${emoji.url}" alt="${`[${emoji.type}_${emoji.icon || emoji.name}]`}" contenteditable="false" draggable="true"/>`
  }
  private getEmojiImgDom (emoji, wait = false) {
    if (wait) {
      const waitClass = `wait-${Math.random().toString(36).substring(2, 15)}`
      const html = `<span class="wait-emoji ${waitClass}" data-emoji="${emoji.slice(1, -1)}"></span>`
      this.waitRenderEmojis.push(waitClass)
      return html
    }
    const url = formatMeMeUrl(emoji.url, 'emoji')
    
    const html = `<img class="small w-[22px] h-[22px] inline" data-emoji="1" src="${url}" alt="${`[${emoji.type}_${emoji.icon || emoji.name}]`}" />`
    return html
  }
}

const render = new EmojiRender()

export default render